(ns bp-clients.tv-app.utils.local-storage
  "Namespace for local-storage util functions."
  (:require [cljs.reader :as reader]
            [goog.storage.mechanism.HTML5LocalStorage]
            [goog.storage.Storage]))

(def ^:private local-storage-namespace
  "Namespace used for localstorage keys"
  "bp.tv-app.")

(def ^:private with-namespace
  "Prepends local-storage namespace"
  (partial str local-storage-namespace))

(def ^:private
  storage-mechanism
  "Storage mechanism"
  (goog.storage.mechanism.HTML5LocalStorage.))

(def ^:private storage
  "Storage object reference"
  (goog.storage.Storage. storage-mechanism))

(defn clear!
  "Clears local-storage"
  []
  (.clear storage-mechanism))

(defn set-item!
  "Sets Key with Value in local-storage"
  ([k v]
   (set-item! k v with-namespace))
  ([k v ns-fn]
   (.set storage (ns-fn k) (pr-str v))))

(defn remove-item!
  "Removes Key from local-storage"
  ([k]
   (remove-item! k with-namespace))
  ([k ns-fn]
   (.remove storage (ns-fn k))))

(defn get-item
  "Read key from local-storage"
  ([k]
   (get-item k nil with-namespace))
  ([k not-found]
   (get-item k not-found with-namespace))
  ([k not-found ns-fn]
   (let [value (.get storage (ns-fn k))]
     (if (undefined? value)
       not-found
       (reader/read-string value)))))
